import { useRef } from "react";
import { type Location, useLocation } from "react-router";

/**
 * Keep track of the current location changes in order to provide the previous rendered location that's different
 * from the current rendered one
 * @param currentLocation - The current location to compare with the useLocation hook
 * @returns The previous location that was rendered
 */
export default function usePreviousLocation(currentLocation: Location | null = null): Location | null {
  const currentLocationHook = useLocation();
  const _currentLocation = currentLocation ?? currentLocationHook;

  const lastRenderLocationRef = useRef<Location | null>(null);
  const lastLocationRef = useRef<Location | null>(null);

  // eslint-disable-next-line react-hooks/refs -- Legacy
  if (!!lastRenderLocationRef.current && lastRenderLocationRef.current.key !== _currentLocation.key)
    // eslint-disable-next-line react-hooks/refs -- Legacy
    lastLocationRef.current = lastRenderLocationRef.current;

  // eslint-disable-next-line react-hooks/refs -- Legacy
  lastRenderLocationRef.current = _currentLocation;

  // eslint-disable-next-line react-hooks/refs -- Legacy
  return lastLocationRef.current;
}
